<template>
  <div>
  <b-jumbotron bg-variant="dark" class="access-denied-page" text-variant="light" border-variant="dark">
    <template #header><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Inadequate Permissions. <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i></template>

    <template #lead>
      Looks like you don't have enough permissions to access this section of the web application.  If you need to access this section for your work, please contact the developer.
    </template>

    <hr class="my-4">

    <h3>
      If it was a mistake, no problem :) 
    </h3>

    <h4>Feel free to explore other sections of the project.</h4>
  </b-jumbotron>
</div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
.access-denied-page{
   background-color: #20303d !important;
   height: calc(100vh - 200px);
   & *{
     text-shadow: 2px 2px 0 rgb(255, 47, 47) !important; 
   }
}
</style>